// extracted by mini-css-extract-plugin
module.exports = {"form-wrapper":"styles_form-wrapper__Ap3LN"};